<template>
    <section id="how-works">
        <div >
            <iframe ref="howItWorks" src="https://slides.com/crossprom/crossprom/embed" width="100%" style="min-height: calc(100vh - 75px)" scrolling="no" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        </div>
    </section>
</template>

<script>
export default {
    name: 'howitworks',

}
</script>

<style>

</style>